import { CreatePartnerRequestApiResponse } from "../types/api";
import { CreatePartnerRequestResponse } from "../types/domain";

export const transformToCreatePartnerRequest = (
  response: CreatePartnerRequestApiResponse
): CreatePartnerRequestResponse => response;
